<template>
  <v-form ref="form" >

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>      

      <v-col cols="12" sm="12" md="12">
        <v-autocomplete
          v-model="entry.manufacturingLotId"
          v-bind="getObject('manufacturingLotId')"
          label="Lote"
          :items="this.lotItemsList"
          @input="changeSelectedItem"          
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
        <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title class="text-subtitle-1">{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>
                Qtd. disponível: {{data.item.formatedAvailableQuantity}} {{packaging.basicUnitName}} - Qtd. de emb.: {{data.item.packagingQuantity}} {{data.item.packagingName}}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="data.item.sowing != '-' || data.item.allocate != '-'">
                Semeio: {{data.item.sowing}}, Destinação: {{data.item.allocate}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          :inputData.sync="entry.packagingQuantity"
          mask-type="currency_10d"
          label="Quantidade de Embalagens"
          @update:inputData="changePackagingQuantity"
          autocomplete="off"
          :hint="packagingHint"
          persistent-hint
          :suffix="packaging ? packaging.text : ''"
          :key="packagingQuantityKey + 'packagingQuantity'"
        />
        <!--   -->
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('quantity')"          
          :inputData.sync="entry.quantity"
          mask-type="currency_10d"
          label="Quantidade Unitária"          
          @update:inputData="changeQuantity"
          :hint="quantityHint"
          persistent-hint
          autocomplete="off"
          :suffix="entry.item ? entry.item.unit.name : ''"
          :key="quantityKey + 'quantity'"
        />
        <!-- -->
      </v-col>
     
    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue"
import DateField from "@shared_components/date_field.vue";

export default {
  data() {
    return {
      entryAttributes: {},      
      lotItemsList: [],
      renderComponent: true,
      itemsSearch: "",      
      packagingQuantity: 0,
      packagingQuantityKey: 0,
      quantityKey: 0,      
      pageLoading: false,
      itemSelected: {},
      availableQuantity: 0,
      interizator: 10000000000.0,
    };
  },
  props: {
    entry: Object,
    originalEntry: Object,
    movementItem: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
    packaging: Object,
    itemLots: {
      type: Array,
      default: new Array(),
    },
    storageAdjustment: Object,
    isNewItemInStorage: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    DateField: DateField,
  },
  created() {    
    // console.log("form created", this.entry);
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // this.entryAttributes.manufacturingLotId.rules = []
    // this.entryAttributes.manufacturingLotId.rules.push(this.requiredRule(true));
    // console.log("item purchase", this.entry.item)        
    if (this.entry.manufacturingLotId) {
      // this.purchaseItemsList = [this.entry.item];
      // this.selectItem(false);
      this.changeSelectedItem();
      this.changePackagingQuantity();
      this.changeQuantity();
    }
    
    this.loadItemLots();    
  },
  mounted() {   
  },
  computed: {
    quantityHint: function() {
      var availableQuantity =  parseFloat(this.itemSelected?.availableQuantity) || 0;
      // if(this.entry.id && this.isEdit){
      //   availableQuantity += this.originalEntry.quantity;
      // }
      return (this.entry.manufacturingLotId && this.itemSelected) ? "Quantidade disponível: " + this.numberToDecimal(availableQuantity) + " " + this.itemSelected?.unitName : "";
    },
    packagingHint: function(){
      return this.packaging.name;
    },
  },
  watch: {
    itemsSearch: function(newSearch, oldSearch) {
      // console.log("newSearch", newSearch, "oldSearch", oldSearch)
      // if (this.itemsSearch && this.itemsSearch.length > 0) {
      //   if (!this.entry.item || this.entry.item.name != this.itemsSearch) {
      //     this.getPurchaseItems();
      //   }
      // }
    },
  },
  methods: {    
    loadItemLots: function(){
      for(var i=0;i<this.itemLots.length; i++){
        this.lotItemsList.push(this.itemLots[i]);
      }      
      // console.log("lotList", this.lotItemsList);      
      this.changeSelectedItem();
    },   
    changeSelectedItem: function(){
      this.itemSelected = this.lotItemsList.find(obj => obj.id == this.entry.manufacturingLotId);      
      // console.log("item", this.itemSelected);
      // console.log("storageAdjustment", this.storageAdjustment);

      // this.itemSelected.unitName = this.packaging.unitName;

      // this.entry.manufacturingLotId = this.itemSelected?.manufacturingLotId;      
      
      this.entryAttributes.quantity.rules = []
      var availableQuantity =  parseFloat(this.itemSelected?.availableQuantity);
      // console.log("entry", this.entry);
      // if(this.entry.id && this.entry.id != null && this.isEdit){
      //   availableQuantity += this.originalEntry.quantity;
      // }
      if(availableQuantity){
        this.entryAttributes.quantity.rules.push(this.maxValueRule(availableQuantity));
      }
            
      this.setItemLot(this.itemSelected);
      
      this.changePackagingQuantity();      
    },    
    changeQuantity: function() {
      this.entry.packagingQuantity = _.round(this.entry.quantity / this.packaging.size, 10);      
      this.packagingQuantityKey++;
      
      // if(this.itemSelected){
      //   this.changeSelectedItem();
      // }
    },
    changePackagingQuantity: function() {
      // console.log("pk size",this.entry.packagingQuantity);
      var temp = (Math.floor(this.entry.packagingQuantity * this.interizator) * this.packaging.size) / this.interizator;
      // console.log("temp", temp);
      this.entry.quantity = _.round(temp, 10);
      // this.entry.quantity = _.round(this.entry.packagingQuantity * this.packaging.size, 10);
      this.quantityKey++;
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },    
    clearFields: function() {
      this.forceRerender(this);
    },
    setItemLot: function(itemLot){
      if(itemLot){
        this.entry.name = itemLot.name;
        this.entry.newName = itemLot.newName;
        this.entry.lotNumber = itemLot.lotNumber;
        this.entry.manufacturingDate = itemLot.manufacturingDate;
        this.entry.dueDate = itemLot.dueDate;
        this.entry.availableQuantity = itemLot.availableQuantity;
        this.entry.unitName = itemLot.unitName;
        this.entry.quantity = itemLot.quantity;
      }
    },
    selectItemLot: function(item){
      // console.log("item", item);
      for (let i in this.lotItemsList){
        // console.log("i", i);
        if(this.lotItemsList[i].id == item){
          this.setItemLot(this.lotItemsList[i]);
        }
      }
      // console.log("entry", this.entry);
    },
    // itemCreated: function(item) {
    //   // console.log("item created", item);
    //   this.lotItemsList.unshift(item);
    //   this.entry.cropLotId = item.id;      
    //   item.quantity = this.quantity;
    //   item.packagingQuantity = this.packagingQuantity;
    //   this.setItemLot(item);
    //   // console.log("item", item);
    //   // this.selectItem(true);
    // },
  }
};

</script>

<style scoped></style>
